<template>
  <div class="section-wrapper student-placement-history">
    <h2 class="section-title">
      {{
        $t("student.placement history title", {
          user: studentName
        })
      }}
    </h2>
    <div v-if="tests && levels">
      <van-collapse
        v-model="activeCollapses"
        v-for="(level, index) in levels"
        :key="`level-${index}`"
      >
        <van-collapse-item
          :name="index"
          :disabled="getPlacementHistoryCount(level) <= 0"
        >
          <template #title>
            <h3 class="box-title">
              {{ $t("student.placement level", { name: level }) }}
            </h3>
          </template>
          <template #icon>
            <i
              class="fas fa-clipboard-list"
              style="display: flex;align-self: center;"
            />
          </template>
          <template #value> x {{ getPlacementHistoryCount(level) }}</template>
          <ol
            class="placement-history-list"
            v-if="getPlacementHistoryCount(level) > 0"
          >
            <li
              v-for="(result, index) in getPlacementHistory(level)"
              :key="index"
            >
              {{
                $t("student.placement name", {
                  name: result.placement_test_name
                })
              }}:
              {{ formatDatetime(result.created) }}
              <small>({{ formatFromNow(result.created) }})</small>
              <span class="score"
                >{{
                  $t("student.placement score", {
                    score: result.score
                  })
                }}
              </span>

              <van-button
                :to="{
                  name: 'review-placement-test-result',
                  params: {
                    result_id: result.id,
                    test_id: result.placement_test_id
                  }
                }"
              >
                <span><i class="fas fa-bar" /> {{ $t("Review test") }}</span>
              </van-button>
            </li>
          </ol>
        </van-collapse-item>
      </van-collapse>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import formatTS from "@/mixins/momentMixin";

export default {
  name: "StudentPlacementtestHistory",
  components: {},
  mixins: [formatTS],
  data() {
    return {
      studentId: -1,
      classroomId: -1,
      activeCollapses: [],
      tests: [],
      levels: []
    };
  },
  methods: {
    ...mapActions("vokabel", ["getClassroom"]),
    ...mapActions("placementTest", ["listStudentPlacementTestResults"])
  },
  computed: {
    ...mapState("vokabel", ["classroom"]),
    ...mapGetters("vokabel", ["getUsername"]),
    ...mapGetters("placementTest", ["getStudentPlacementTestResults"]),
    classroomData() {
      const { classroom } = this;
      return classroom.data ? classroom.data : {};
    },
    studentName() {
      let name = this.getUsername(
        this.studentId,
        this.classroomData ? this.classroomData.members_list : []
      );
      return name;
    },
    getPlacementHistory() {
      return level => {
        if (!this.tests || !this.tests["results"]) {
          return [];
        }

        let all = this.tests["results"];
        let result = all.filter(r => {
          return (
            r["placement_test_level"] && r["placement_test_level"] == level
          );
        });
        return result;
      };
    },
    getPlacementHistoryCount() {
      return level => this.getPlacementHistory(level).length;
    }
  },
  mounted() {
    this.studentId = this.$route.params.student_id;
    this.classroomId = this.$route.params.classroom_id;
    this.getClassroom(this.classroomId);
    this.listStudentPlacementTestResults(this.studentId)
      .then(() => {
        this.tests = this.getStudentPlacementTestResults(this.studentId);
      })
      .then(() => {
        if (!this.tests || !this.tests["results"]) {
          this.levels = [];
        }
        let all = this.tests["results"];
        let levels = new Set();
        all.forEach(t => {
          levels.add(t["placement_test_level"]);
        });
        this.levels.splice(
          0,
          this.levels.length,
          ...Array.from(levels.values())
        );
      });
  }
};
</script>
<style lang="scss">
@import "@/assets/styles.scss";
.box-title {
  margin-left: 14px;
}
ol.placement-history-list {
  overflow-y: auto;
  min-height: 25px;
  max-height: 20vh;
  margin-left: 16px !important;
  margin-right: 16px !important;
  width: 100%;
  list-style: inside decimal !important;
  li {
    margin-bottom: 4px;
  }
}
span.score {
  color: $maintext;
  font-size: 1.1em;
  margin: 3px 8px;
}
</style>
